export const numberToHumanReadable = (number?: number): string => {
  if (number === undefined) return `-`;

  return number % 1 !== 0 ? number.toFixed(2) : `${number}`;
};
